<template>
    <el-dialog
    title="留言板详情"
    class="centerDialog"
    :visible.sync="visible"
    :close-on-click-modal='false'
    :append-to-body="true"
    :modal-append-to-body='false'
    @closed="reset"
    width="35%">
    <el-form class="form" ref="form" :model="dataForm" label-width="80px" label-suffix=' :'>
        <el-form-item class="inp_width" label="发布者">
            <span>{{dataForm.name}}</span>
        </el-form-item>
        <el-form-item label="内容">
            <el-input v-model="dataForm.content" type="textarea" :rows=4 resize="none" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item class="inp_width" label="创建时间">
            <span>{{dataForm.createTime}}</span>
        </el-form-item>
        <el-form-item class="inp_width" label="是否显示">
            <span>{{dataForm.status === 2?'显示':'不显示'}}</span>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">返回</el-button>
    </span>
</el-dialog>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        name: null,
        content: null,
        createTime: null,
        status: null
      }
    };
  },
  methods: {
    init (row) {
      this.visible = true;
      let { name, content, status, createTime } = row;
      this.dataForm = {
        name,
        content,
        status,
        createTime
      };
    },
    reset () {
      this.dataForm = {
        name: null,
        content: null,
        createTime: null,
        status: null
      };
    }
  }
};
</script>
<style lang="scss">
.centerDialog {
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
  .form {
    width: 85%;
    margin: 0 auto;
    .inp_width {
      width: 245px;
    }
  }
}
</style>
